<template>
  <form @submit.prevent="save_event" class="mt-8">

    <memlist-select-input2
      id="category_id"
      :title="$t('EVENT.CATEGORY')"
      v-model="local_item.category_id"
      :items="event_categories_options"
      layout="vertical"
      size="sm"
      validation_type="TEXT"
      @input="on_change"
    />

    <memlist-card :title="$t('EVENT.SIGNUPS')" class="mt-8">
      
      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="open_setting"
            v-model="local_item.open_setting"
            value="PUBLIC"
            @input="on_change"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.OPEN_FOR_ALL')}}</span>
      </div>

      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="open_setting"
            v-model="local_item.open_setting"
            value="ANY_MEMBER"
            @input="on_change"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.ANY_MEMBER')}}</span>
      </div>

      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="open_setting"
            v-model="local_item.open_setting"
            value="COMPANY_MEMBER_PAID"
            @input="on_change"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.COMPANY_MEMBER_PAID')}}</span>
      </div>

      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="open_setting"
            v-model="local_item.open_setting"
            value="ANY_MEMBER_PAID"
            @input="on_change"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.ANY_MEMBER_PAID')}}</span>
      </div>

      <memlist-select-input2
        class="mt-8"
        id="ticket_template_id"
        name="ticket_template_id"
        :title="$t('EVENT.TICKET_TEMPLATE_ID')"
        layout="vertical"
        validation_type="TEXT"
        v-model="local_item.ticket_template_id"
        :items="email_templates_options"
        :placeholder="$t('EVENT.TICKET_TEMPLATE_ID')"
        :invalid_text="''"
        :info_text="''"
        @input="on_change"
      />


      <h4 class="mt-8">{{ $t('MEMBER_PROPERTY.QUESTIONEER') }}</h4>
      <p style="font-style: italic;">{{ $t('MEMBER_PROPERTY.QUESTIONEER_INFO') }}</p>
      
      <AttributeGroupSelectButton
        :group_ids="local_item.group_ids"
        @selected="property_groups_selected"
      />
      
      <p class="mt-4"><a href="/ml-properties">{{ $t('MEMBER_PROPERTY.ADMINISTER') }} >></a></p>
    </memlist-card>

    <memlist-card :title="$t('EVENT.TERMS')" class="mt-4 mb-8">

      <memlist-checkbox 
        :text="$t('EVENT.MUST_ACCEPT')"
        style="margin-top: 20px;"
        v-model="local_item.has_terms"
        @input="on_change"
      />

      <label class="mt-4 mb-2 d-block bold">{{$t('EVENT.TERMS_TEXT')}}</label>
      <memlist-tiptap 
        v-model="local_item.terms" 
        @input="on_change"
      />

    </memlist-card>

    <div class="ml-8">

      <h4>{{ $t('EVENT.VAT_OPTION') }}</h4>

      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="vat_option"
            v-model="local_item.vat_option"
            value="INC_VAT"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.VAT_OPTIONS.INC_VAT')}}</span>
      </div>
      <div class="d-flex align-items-center">
        <label class="radio radio-list radio-outline radio-success">
          <input
            type="radio"
            name="vat_option"
            v-model="local_item.vat_option"
            value="EX_VAT"
          />
          <span></span>
        </label>
        <span class="ml-3 cursor-pointer">{{$t('EVENT.VAT_OPTIONS.EX_VAT')}}</span>
      </div>


    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import AttributeGroupSelectButton from '@/view/components/attribute_group_selector/AttributeGroupSelectButton.vue';
import { mapGetters } from 'vuex';


export default {
props: ['item'],
components: {
  AttributeGroupSelectButton
},
mixins: [ toasts ],
computed: {
  ...mapGetters(['companies', 'currentCompanyId', 'currentPeriodId']),
  },
  
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));

        this.load_event_categories();
        this.load_templates();
      },
      immediate: true
    },

  },
  methods: {
    save_event() {},
    on_change() {
      setTimeout(()=>{
        this.$emit('change', this.local_item);
      },100);
    },


    property_groups_selected(group_ids) {
      this.local_item.group_ids = group_ids;
      this.local_item = { ...this.local_item }
    },
    async load_event_categories() {
      try {
        const res = await axios.get(`/event_category`)
      
        if (res.status === 200) {

          this.event_categories_options = [];

          for (const ec of res.data) {
            this.event_categories_options.push({
              value: ec.id,
              text: ec.name
            });
          }
        }
        
      }
      catch (err) {
        console.error('load_event_categories error', err);
      }
      
    },

    async load_templates() {
      try {
        this.email_templates_options = [];

        const res = await axios.get(`/template?company_id=${this.currentCompanyId}`)
  
        if (res.status === 200) {
          const templates = res.data;

          console.log(templates);

          for (var i = 0; i < templates.length; ++i) {
            if (!templates[i].is_sms) {
              this.email_templates_options.push({
                value: templates[i].template_id,
                text: templates[i].name
              });
            }
          }

          console.log(this.email_templates_options);
        }
      }
      catch (err) {
        console.error('load_templates error', err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
      }
      
    },
  },
  data() {
    return {
      local_item: {},
      event_categories_options: [],
      email_templates_options: []
    }
  },
}
</script>
